import { Button } from "antd";

export default function PendingApproval() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #F6EAFF", backgroundColor: "#F6EAFF66" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/pending_approval.svg" alt="" />
        <Button htmlType="button" className="blue-btn btn-sm" type="primary">
          Approve
        </Button>
      </div>
      <h5> Pending approval </h5>
      <h6> Awaiting approval from Artem. </h6>
    </div>
  );
}
